import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Navigation
      "nav.home": "Accueil",
      "nav.rental": "Location",
      "nav.sales": "Ventes",
      "nav.parts": "Pièces",
      "nav.software": "Logiciels",
      "nav.services": "Services",
      "nav.realizations": "Réalisations",
      "nav.contact": "Contact",
      "nav.cart": "Panier",
      "nav.account": "Mon Compte",
      "nav.login": "Connexion",
      "nav.logout": "Déconnexion",
      "nav.admin": "Administration",
      
      // Hero
      "hero.title": "Votre équipe d'experts pour vos projets d'affichage numérique",
      "hero.subtitle": "Découvrez comment notre entreprise révolutionne la communication avec ses services d'affichage dynamique.",
      "hero.cta": "Découvrir nos services",
      "hero.contact": "Nous contacter",
      
      // Stats
      "stats.years": "Années d'expérience",
      "stats.support": "Support 24/7/365",
      "stats.countries": "Pays desservis",
      "stats.clients": "Clients satisfaits",
      
      // Departments
      "dept.rental": "Location",
      "dept.rental.desc": "Location d'équipements pour l'affichage dynamique et interactif temporaire",
      "dept.sales": "Ventes",
      "dept.sales.desc": "Équipements neufs et usagés avec livraison et installation",
      "dept.parts": "Pièces",
      "dept.parts.desc": "Pièces de rechange pour vos équipements d'affichage",
      "dept.software": "Logiciels",
      "dept.software.desc": "Licences mensuelles et annuelles pour nos solutions logicielles",
      "dept.services": "Services",
      "dept.services.desc": "Entretien, programmation, installation et wrap de bornes",
      
      // Products
      "product.addToCart": "Ajouter au panier",
      "product.rent": "Réserver",
      "product.buy": "Acheter",
      "product.subscribe": "S'abonner",
      "product.availability": "Disponibilité",
      "product.available": "Disponible",
      "product.unavailable": "Non disponible",
      "product.price": "Prix",
      "product.perDay": "/jour",
      "product.perWeek": "/semaine",
      "product.perMonth": "/mois",
      "product.perYear": "/an",
      "product.new": "Neuf",
      "product.used": "Usagé",
      "product.inStock": "En stock",
      "product.outOfStock": "Rupture de stock",
      
      // Rental
      "rental.title": "Location d'équipements",
      "rental.selectDates": "Sélectionnez vos dates",
      "rental.startDate": "Date de début",
      "rental.endDate": "Date de fin",
      "rental.checkAvailability": "Vérifier la disponibilité",
      "rental.estimate": "Estimation",
      "rental.deposit": "Dépôt",
      "rental.taxes": "Taxes",
      "rental.total": "Total",
      "rental.book": "Réserver maintenant",
      
      // Cart
      "cart.title": "Votre panier",
      "cart.empty": "Votre panier est vide",
      "cart.subtotal": "Sous-total",
      "cart.delivery": "Livraison",
      "cart.installation": "Installation",
      "cart.taxes": "Taxes (TPS+TVQ)",
      "cart.total": "Total",
      "cart.checkout": "Passer la commande",
      "cart.continue": "Continuer vos achats",
      
      // Auth
      "auth.login": "Connexion",
      "auth.register": "Créer un compte",
      "auth.email": "Courriel",
      "auth.password": "Mot de passe",
      "auth.name": "Nom complet",
      "auth.phone": "Téléphone",
      "auth.company": "Entreprise",
      "auth.forgotPassword": "Mot de passe oublié?",
      "auth.noAccount": "Pas encore de compte?",
      "auth.hasAccount": "Déjà un compte?",
      "auth.googleLogin": "Connexion avec Google",
      
      // Account
      "account.title": "Mon Compte",
      "account.profile": "Profil",
      "account.orders": "Mes commandes",
      "account.rentals": "Mes locations",
      "account.licenses": "Mes licences",
      "account.invoices": "Mes factures",
      
      // Contact
      "contact.title": "Nous contacter",
      "contact.subtitle": "Transformez votre espace avec nos solutions d'affichage",
      "contact.name": "Votre nom",
      "contact.email": "Votre courriel",
      "contact.phone": "Votre téléphone",
      "contact.company": "Votre entreprise",
      "contact.subject": "Sujet",
      "contact.message": "Message",
      "contact.send": "Envoyer",
      "contact.success": "Message envoyé avec succès!",
      "contact.support": "Support technique 24/7",
      
      // Footer
      "footer.about": "À propos",
      "footer.privacy": "Politique de confidentialité",
      "footer.terms": "Conditions d'utilisation",
      "footer.rights": "Tous droits réservés",
      
      // Common
      "common.loading": "Chargement...",
      "common.error": "Une erreur est survenue",
      "common.success": "Succès!",
      "common.cancel": "Annuler",
      "common.save": "Sauvegarder",
      "common.delete": "Supprimer",
      "common.edit": "Modifier",
      "common.view": "Voir",
      "common.search": "Rechercher",
      "common.filter": "Filtrer",
      "common.all": "Tous",
      "common.download": "Télécharger",
    }
  },
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.rental": "Rentals",
      "nav.sales": "Sales",
      "nav.parts": "Parts",
      "nav.software": "Software",
      "nav.services": "Services",
      "nav.realizations": "Portfolio",
      "nav.contact": "Contact",
      "nav.cart": "Cart",
      "nav.account": "My Account",
      "nav.login": "Login",
      "nav.logout": "Logout",
      "nav.admin": "Admin",
      
      // Hero
      "hero.title": "Your expert team for digital signage projects",
      "hero.subtitle": "Discover how our company revolutionizes communication with our digital signage services.",
      "hero.cta": "Discover our services",
      "hero.contact": "Contact us",
      
      // Stats
      "stats.years": "Years of experience",
      "stats.support": "24/7/365 Support",
      "stats.countries": "Countries served",
      "stats.clients": "Satisfied clients",
      
      // Departments
      "dept.rental": "Rentals",
      "dept.rental.desc": "Equipment rental for temporary digital and interactive signage",
      "dept.sales": "Sales",
      "dept.sales.desc": "New and used equipment with delivery and installation",
      "dept.parts": "Parts",
      "dept.parts.desc": "Replacement parts for your signage equipment",
      "dept.software": "Software",
      "dept.software.desc": "Monthly and annual licenses for our software solutions",
      "dept.services": "Services",
      "dept.services.desc": "Maintenance, programming, installation and kiosk wrapping",
      
      // Products
      "product.addToCart": "Add to cart",
      "product.rent": "Book",
      "product.buy": "Buy",
      "product.subscribe": "Subscribe",
      "product.availability": "Availability",
      "product.available": "Available",
      "product.unavailable": "Unavailable",
      "product.price": "Price",
      "product.perDay": "/day",
      "product.perWeek": "/week",
      "product.perMonth": "/month",
      "product.perYear": "/year",
      "product.new": "New",
      "product.used": "Used",
      "product.inStock": "In stock",
      "product.outOfStock": "Out of stock",
      
      // Rental
      "rental.title": "Equipment Rental",
      "rental.selectDates": "Select your dates",
      "rental.startDate": "Start date",
      "rental.endDate": "End date",
      "rental.checkAvailability": "Check availability",
      "rental.estimate": "Estimate",
      "rental.deposit": "Deposit",
      "rental.taxes": "Taxes",
      "rental.total": "Total",
      "rental.book": "Book now",
      
      // Cart
      "cart.title": "Your cart",
      "cart.empty": "Your cart is empty",
      "cart.subtotal": "Subtotal",
      "cart.delivery": "Delivery",
      "cart.installation": "Installation",
      "cart.taxes": "Taxes (GST+QST)",
      "cart.total": "Total",
      "cart.checkout": "Checkout",
      "cart.continue": "Continue shopping",
      
      // Auth
      "auth.login": "Login",
      "auth.register": "Create account",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.name": "Full name",
      "auth.phone": "Phone",
      "auth.company": "Company",
      "auth.forgotPassword": "Forgot password?",
      "auth.noAccount": "Don't have an account?",
      "auth.hasAccount": "Already have an account?",
      "auth.googleLogin": "Login with Google",
      
      // Account
      "account.title": "My Account",
      "account.profile": "Profile",
      "account.orders": "My orders",
      "account.rentals": "My rentals",
      "account.licenses": "My licenses",
      "account.invoices": "My invoices",
      
      // Contact
      "contact.title": "Contact us",
      "contact.subtitle": "Transform your space with our signage solutions",
      "contact.name": "Your name",
      "contact.email": "Your email",
      "contact.phone": "Your phone",
      "contact.company": "Your company",
      "contact.subject": "Subject",
      "contact.message": "Message",
      "contact.send": "Send",
      "contact.success": "Message sent successfully!",
      "contact.support": "24/7 Technical Support",
      
      // Footer
      "footer.about": "About",
      "footer.privacy": "Privacy Policy",
      "footer.terms": "Terms of Service",
      "footer.rights": "All rights reserved",
      
      // Common
      "common.loading": "Loading...",
      "common.error": "An error occurred",
      "common.success": "Success!",
      "common.cancel": "Cancel",
      "common.save": "Save",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.view": "View",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.all": "All",
      "common.download": "Download",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
